import { Pipe, PipeTransform } from '@angular/core';
import { PermissionManagerService } from "./permissions.service";

@Pipe({
  name: 'appRestriction'
})
export class RestrictionPipe implements PipeTransform {
  constructor(private permissionManagerS: PermissionManagerService){}

  transform(permission: string): boolean {
    const [keyName, type, action] = permission.split("|");

    const restriction = this.permissionManagerS.hasRestriction(
      keyName,
      type,
      action
    );

    return !!restriction;
  }
}
